<template>

  <div class="eco-amaps-component" id="order-process-wrap">

    <div class="content-with-sidebar-component" ref="documentContainer">

      <div class="container">

        <div class="row">

          <!-- Body -->
          <div class="col-8 body">

            <div class="row p-0">
              <div class="col-12 text-center">
                <div class="progress-bar-component">
                  <router-link :to="{ name: 'ECO / AMAPS Personal Details', params: { quoteId: this.$route.params.quoteId } }" class="router-link-active">
                    Personal<br>Details
                  </router-link>

                  <a v-if="!stepOneAgreed" href="#" @click="()=>{return false;}">Vehicle<br>Details</a>
                  <router-link v-else :to="{ name: 'ECO / AMAPS Product Details', params: { quoteId: this.$route.params.quoteId } }"
                    class="router-link-active">
                    Vehicle<br>Details
                  </router-link>

                  <a v-if="!stepTwoAgreed" href="#" @click="()=>{return false;}">Order<br>Details</a>
                  <router-link v-else
                    :to="{ name: 'ECO / AMAPS Order Details', params: { quoteId: this.$route.params.quoteId } }"
                    class="router-link-active">
                    Order<br>Details
                  </router-link>
                </div>

              </div>
            </div>

            <div>
              <h2 class="title">{{ heading }}</h2>
            </div>

            <div>
              <transition name="fade" mode="out-in">
                <router-view
                  v-if="currentProduct"
                  :session="session"
                  :cashAllowance="cashAllowance"
                  :confirmations="confirmations"
                  :optionSelections="optionSelections"
                  :contact="contact"
                  :derivative="derivative"
                  :driver-grade="driverGrade"
                  :driverProfile="driverProfile"
                  :orderType="orderType"
                  :quote="quote"
                  :orderSummaryView="true"
                  :adminPortalData="adminPortalData"
                  :sectionOneHeading="sectionOneHeading"
                  :sectionTwoHeading="sectionTwoHeading"
                  :sectionThreeHeading="sectionThreeHeading"
                  :currentProduct="currentProduct"
                >
                </router-view>
              </transition>
            </div>

            <footer-text v-if="footerText" :footerText="footerText"/>

          </div>

          <!-- Sidebar -->
          <div class="col-4 sidebar">
            <cost-summary
              :type="orderType"
              :currentProduct="currentProduct"
              :adminPortalData="adminPortalData"
              :quote="quote"
              :confirmations="confirmations"
              :driver-profile="driverProfile">
            </cost-summary>
          </div>

        </div>
      </div>

    </div>

  </div>


</template>
<script>
import CostSummary from "./cost-summary";
import {EventBus} from '@/event-bus.js';
import FooterText from "../../footer/footer-text";

export default {
  name: 'ecoamaps-order-process-component',
  components: {FooterText, CostSummary, EventBus},
  props: [
    'adminPortalData',
    'session'
  ],

  beforeRouteEnter(to, from, next) {
    next(vm => {
      EventBus.$emit('fetchData', ['driverprofile', 'drivergrades']);
      vm.fetchQuote();
    })
  },

  mounted() {
    switch (this.$router.currentRoute.name) {
      case "ECO / AMAPS Personal Details":
        break;
      case "ECO / AMAPS Product Details":
        if (!this.stepOneAgreed) {
          this.$router.push({name: 'ECO / AMAPS Personal Details'});
          return false;
        }
        break;
      case "ECO / AMAPS Order Details":
        if (!this.stepOneAgreed || !this.stepTwoAgreed) {
          this.$router.push({name: 'ECO / AMAPS Personal Details'});
          return false;
        }
        break;
    }
    EventBus.$on('setConfirmations', (confirmations) => {
      this.confirmations = confirmations;
    });
  },

  data: () => {
    return {
      orderType: 'PCH',
      confirmations: {
        employeeDetails: false,
        correctVehicle: false,
        creditSaleDetails: false,
        furtherSalaryDeductions: false,
        fullVehicleMaintenance: false,
        motorInsuranceProduct: false,
        earlyTerminationInsurance: false,
        schemePolicy: false,
        privacyNotice: false,
        keyPolicyPoints: false
      },
      optionSelections: {},
      cashAllowance: null,
      contact: null,
      derivative: null,
      driverGrade: null,
      driverProfile: null,
      quote: null,
    }
  },

  watch: {
    currentProduct(currentProduct) {
      currentProduct.order_stage_extra_options.forEach((option => {
        this.$set(this.optionSelections, option.title, option.option_default === '1' ? true : false);
      }));
    },
    session(value) {
      if (value.driverProfile) {
        this.driverProfile = value.driverProfile;
        this.contact = value.driverProfile.contacts[0];
        this.driverGrade = value.driverProfile.driverGrades['ecoamaps'].grades[this.quote.definition.driverGradeID];
        this.cashAllowance = value.driverProfile.currentCashAllowances.totalAnnualCurrentAllowance;

        this.driverProfile.fullName = value.driverProfile.contacts[0].fullName;
        this.driverProfile.emailAddress = value.driverProfile.contacts[0].emailAddress;
        this.driverProfile.mobile = value.driverProfile.contacts[0].mobile;
        this.driverProfile.homeAddress = value.driverProfile.homeAddress.replace(/(?:\r\n|\r|\n)/g, ', ');

        const n = this.driverProfile.homeAddress.lastIndexOf(',');
        this.driverProfile.postcode = this.driverProfile.homeAddress.substring(n + 1)
        this.driverProfile.homeAddress = this.driverProfile.homeAddress.substring(0, n);

        this.driverProfile.companyCarGrade = this.driverGrade.name;
        this.driverProfile.privateCarGrade = this.driverGrade.name;
        this.driverProfile.totalAnnualMileage = Number(value.driverProfile.annualBusinessDistance) + Number(value.driverProfile.annualPrivateDistance);
        this.driverProfile.businessAnnualMileage = Number(value.driverProfile.annualBusinessDistance);
        this.driverProfile.privateAnnualMileage = Number(value.driverProfile.annualPrivateDistance);
        this.driverProfile.companyCarMileageReimbursementMethod = value.driverProfile.homeElectricityReimbursementName_CompanyCar;
        this.driverProfile.privateCarMileageReimbursementMethod = value.driverProfile.homeElectricityReimbursementName_PrivateCar;

        this.cashAllowance = value.driverProfile.currentCashAllowances.totalAnnualCurrentAllowance;
      }
    },
    stepOneAgreed(value) {
      this.$emit('stepOneAgreed', value);
    },
    stepTwoAgreed(value) {
      this.$emit('stepTwoAgreed', value);
    },
    stepThreeAgreed(value) {
      this.$emit('stepThreeAgreed', value);
    },
    $route(to, from) {
      this.scrollToTop();
    }
  },

  computed: {
    quoteExpired() {
      return new Date(this.quote?.details?.quoteExpiryDate) < new Date();
    },
    currentQuote() {
      if (!this.quote.taxCalculations) {
        return false;
      }
      return this.quote.taxCalculations.calculationResults.slice(-1)[0];
    },
    currentProduct() {
      return this.adminPortalData.content?.products?.ecoamaps[0] ? this.adminPortalData.content.products.ecoamaps[0] : false;
    },
    heading() {
      if (!this.adminPortalData.content) return '';
      return this.adminPortalData.content.products.ecoamaps[0].order_stage_one_heading;
    },
    sectionOneHeading() {
      return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_one_section_one_title : '';
    },
    sectionTwoHeading() {
      return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_two_section_two_title : '';
    },
    sectionThreeHeading() {
      return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_section_three_title : '';
    },
    stepOneAgreed() {
      return (this.confirmations.employeeDetails);
    },
    stepTwoAgreed() {
      return (this.confirmations.correctVehicle);
    },
    stepThreeAgreed() {
      return (
        this.confirmations.creditSaleDetails &&
        this.confirmations.furtherSalaryDeductions &&
        this.confirmations.fullVehicleMaintenance &&
        this.confirmations.motorInsuranceProduct &&
        //this.confirmations.earlyTerminationInsurance &&
        this.confirmations.schemePolicy
      );
    },
    footerText() {
      return this.adminPortalData.content?.products?.ecoamaps
      && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description_required
      && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description
      && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_description_required_on_order_process
        ? this.adminPortalData.content.products.ecoamaps[0].fca_requirement_and_content_fca_description
        : false;
    },
  },

  methods: {
    getMonthlyCost(value) {
      return (Number(value) / this.quote.term).toFixed(2);
    },
    scrollToTop() {
      this.$nextTick(() => {
        this.$refs.documentContainer.scrollTop = 0;
      });
    },

    /**
     * Get the quote
     * @returns {Promise<void>}
     */
    async fetchQuote() {
      EventBus.$emit('loading', true);

      try {
        // Moved to it's own endpoint to save the faffing
        const response = await this.$http.post('/api/quote/' + this.$route.params.quoteId);
        this.quote = response.data;

        if (this.quoteExpired) {
          Vue.notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: "This quote has expired. Please refresh the quote, or select another vehicle."
          });

          this.$router.push({name: 'Car Comparison'});
        }

      } catch (err) {
        let response = err.response.data;

        this.$notify({
          group: 'notify',
          type: 'error',
          title: 'Error',
          text: response.message
        });
      }

      EventBus.$emit('loading', false);
    }
  }
}
</script>
